import { KeyboardArrowUp } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import React from 'react';

interface ListBackToTopBarProps {
  onBackToTop: () => void;
  disabled?: boolean;
}

/** Footer control under CRM list viewports — scrolls the list back to the start. */
const ListBackToTopBar: React.FC<ListBackToTopBarProps> = ({
  onBackToTop,
  disabled = false,
}) => (
  <Box
    sx={{
      flexShrink: 0,
      display: 'flex',
      justifyContent: 'center',
      py: 1,
      px: 1.5,
      borderTop: 1,
      borderColor: 'divider',
      bgcolor: 'background.paper',
    }}
  >
    <Button
      size="small"
      startIcon={<KeyboardArrowUp />}
      onClick={onBackToTop}
      disabled={disabled}
      sx={{ fontWeight: 600 }}
    >
      Back to top
    </Button>
  </Box>
);

export default ListBackToTopBar;
